import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import css from '../css/study.m.css';
import { MicroCard } from './mc-card';
const factory = create({
    theme
}).properties();
export const MicroCardsView = factory(({ id, properties, middleware: { theme } }) => {
    const { topics = [], onAction } = properties();
    const fixedCss = theme.classes(css);
    return v('div', { id, classes: [theme.variant(), fixedCss.cards] }, topics
        ? topics.map((topic) => {
            return w(MicroCard, { topic, onAction });
        })
        : []);
});
export default MicroCardsView;
